// Contatori diagnostici delle operazioni di telemetria. Specchio di
// `CloseYourIt::Stats` (gem) e `Stats` (dart).

export type StatKey = 'enqueued' | 'sent' | 'dropped' | 'failed'

const KEYS: StatKey[] = ['enqueued', 'sent', 'dropped', 'failed']

export class Stats {
  private counts: Record<StatKey, number> = {
    enqueued: 0,
    sent: 0,
    dropped: 0,
    failed: 0,
  }

  /// Incrementa il contatore [key].
  increment(key: StatKey): void {
    this.counts[key] += 1
  }

  /// Valore corrente di [key].
  get(key: StatKey): number {
    return this.counts[key]
  }

  /// Snapshot dei contatori.
  toObject(): Record<StatKey, number> {
    return { ...this.counts }
  }

  /// Azzera tutti i contatori.
  reset(): void {
    for (const key of KEYS) this.counts[key] = 0
  }
}
